<template>
  <div class="categories-admin" v-if="currentUser">
    <div class="page-header">
      <h1>Zarządzanie specjalizacjami</h1>
      <button class="btn-primary" @click="setFieldAdd">
        {{ showEditAdd && mode === 'add' ? 'Zamknij formularz' : '+ Dodaj specjalizację' }}
      </button>
    </div>

    <div class="layout">
      <div class="section-card">
        <div class="section-card-header">
          <h2>Lista specjalizacji</h2>
        </div>

        <div class="specs-list">
          <div class="spec-item" v-for="spec in specs" :key="spec.id">
            <span class="spec-name">{{ spec.name }}</span>
            <div class="spec-actions">
              <button
                  class="btn-icon"
                  @click="setFieldEdit(spec.name, spec.id)"
                  title="Edytuj"
              >
                <img src="@/assets/icons/pencil-square.svg" alt="Edytuj">
              </button>
              <button
                  class="btn-icon btn-danger"
                  @click="deleteSpec(spec.id)"
                  title="Usuń"
              >
                <img src="@/assets/icons/trash.svg" alt="Usuń">
              </button>
            </div>
          </div>

          <div v-if="specs.length === 0" class="empty-state">
            <p>Brak specjalizacji do wyświetlenia.</p>
          </div>
        </div>
      </div>

      <div class="section-card edit-card" v-if="showEditAdd">
        <div class="section-card-header">
          <h2>{{ mode === 'edit' ? 'Edytuj specjalizację' : 'Dodaj specjalizację' }}</h2>
          <button class="btn-outline" @click="closeForm">Zamknij</button>
        </div>

        <div class="form-group">
          <label for="editAddField">{{ editAddComm }}</label>
          <input
              type="text"
              id="editAddField"
              placeholder="Nazwa specjalizacji..."
              v-model="newSpecName"
          >
        </div>

        <div class="form-actions">
          <button class="btn-green" @click="submitEditAdd">
            {{ mode === 'edit' ? 'Zapisz zmiany' : 'Dodaj' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import authHeader from '@/services/auth-header';
import { useAuthStore } from '@/stores/auth';
import { useAppStore } from '@/stores/app';

export default {
  name: 'SpecsEdit',
  setup() {
    return {
      authStore: useAuthStore(),
      appStore: useAppStore(),
    };
  },
  data() {
    return {
      specs: [],
      showEditAdd: false,
      editAddComm: '',
      specId: '',
      newSpecName: '',
      mode: 'add',
    };
  },
  computed: {
    currentUser() {
      return this.authStore.user;
    },
  },
  mounted() {
    if (!this.currentUser) {
      this.$router.push('/login');
    } else if (this.currentUser.role_id !== 1) {
      this.$router.push('/login');
    }
    this.getSpecs();
  },
  methods: {
    getSpecs() {
      axios.get('/Categories')
          .then(res => {
            this.specs = res.data || [];
          });
    },
    setFieldAdd() {
      if (this.showEditAdd && this.mode === 'add') {
        this.closeForm();
        return;
      }
      this.showEditAdd = true;
      this.mode = 'add';
      this.editAddComm = 'Podaj nazwę nowej specjalizacji';
      this.specId = '';
      this.newSpecName = '';
      window.scrollTo(0, document.body.scrollHeight);
    },
    setFieldEdit(name, id) {
      this.showEditAdd = true;
      this.mode = 'edit';
      this.editAddComm = `Edytujesz: ${name}`;
      this.specId = String(id);
      this.newSpecName = name;
      window.scrollTo(0, document.body.scrollHeight);
    },
    closeForm() {
      this.showEditAdd = false;
      this.editAddComm = '';
      this.specId = '';
      this.newSpecName = '';
      this.mode = 'add';
    },
    submitEditAdd() {
      if (!this.newSpecName || this.newSpecName.trim() === '') {
        this.appStore.setIsAlert('Wpisz nazwę specjalizacji');
        return;
      }

      if (this.mode === 'add') {
        this.addSpec();
      } else {
        this.editSpec();
      }
    },
    addSpec() {
      const ob = {
        name: this.newSpecName.trim(),
      };

      axios.post('/Category', ob, authHeader())
          .then(res => {
            if (String(res.status).charAt(0) === '2') {
              this.appStore.setIsSuccess('Dodano specjalizację');
              this.getSpecs();
              this.closeForm();
            }
          })
          .catch(() => {
            this.appStore.setIsAlert('Nie udało się dodać specjalizacji');
          });
    },
    editSpec() {
      if (!this.specId) return;

      const ob = {
        id: Number(this.specId),
        name: this.newSpecName.trim(),
      };

      axios.post('/Category', ob, authHeader())
          .then(res => {
            if (String(res.status).charAt(0) === '2') {
              this.appStore.setIsSuccess('Zapisano zmiany');
              this.getSpecs();
              this.closeForm();
            }
          })
          .catch(() => {
            this.appStore.setIsAlert('Nie udało się zapisać zmian');
          });
    },
    deleteSpec(id) {
      axios.delete(`/Category/${id}`, authHeader())
          .then(res => {
            if (String(res.status).charAt(0) === '2') {
              this.specs = this.specs.filter(x => x.id !== id);
              this.appStore.setIsSuccess('Usunięto specjalizację');
            }
          })
          .catch(() => {
            this.appStore.setIsAlert('Nie udało się usunąć specjalizacji');
          });
    },
  },
};
</script>

<style scoped>
.categories-admin {
  max-width: 1200px;
  margin: 0 auto;
  padding: 32px 16px;
  font-family: sans-serif;
  box-sizing: border-box;
}

.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 2px solid #e5e7eb;
}

.page-header h1 {
  font-size: 2.8rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0;
}

.layout {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.section-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.08);
  padding: 24px;
  box-sizing: border-box;
  width: 100%;
}

.section-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 14px;
}

.section-card h2 {
  font-size: 2rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0;
}

.specs-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.spec-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 12px;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.spec-item:hover {
  border-color: #10b981;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
}

.spec-name {
  font-size: 1.6rem;
  font-weight: 600;
  color: #1f2937;
  word-break: break-word;
}

.spec-actions {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 16px;
}

.form-group label {
  font-size: 1.5rem;
  font-weight: 600;
  color: #374151;
}

.form-group input {
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 10px 14px;
  font-size: 1.5rem;
  outline: none;
  transition: border-color 0.2s;
  box-sizing: border-box;
  width: 100%;
}

.form-group input:focus {
  border-color: #10b981;
  box-shadow: 0 0 0 2px rgba(16, 185, 129, 0.1);
}

.form-actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.btn-primary {
  background-color: #f97316;
  color: #fff;
  padding: 10px 20px;
  border-radius: 8px;
  border: none;
  font-size: 1.5rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;
}

.btn-primary:hover {
  background-color: #ea6c0a;
}

.btn-green {
  background-color: #10b981;
  color: #fff;
  padding: 10px 16px;
  border-radius: 8px;
  border: none;
  font-size: 1.5rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;
}

.btn-green:hover {
  background-color: #059669;
}

.btn-outline {
  background-color: transparent;
  color: #1f2937;
  padding: 8px 16px;
  border-radius: 8px;
  border: 1px solid #d1d5db;
  font-size: 1.5rem;
  cursor: pointer;
  transition: border-color 0.2s, color 0.2s;
}

.btn-outline:hover {
  border-color: #10b981;
  color: #10b981;
}

.btn-icon {
  background: none;
  border: none;
  cursor: pointer;
  padding: 6px;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  transition: background-color 0.2s;
}

.btn-icon img {
  width: 20px;
  height: 20px;
}

.btn-icon:hover {
  background-color: #f3f4f6;
}

.btn-danger:hover {
  background-color: #fee2e2;
}

.empty-state {
  text-align: center;
  padding: 28px;
  color: #9ca3af;
  font-size: 1.5rem;
  border: 1px dashed #d1d5db;
  border-radius: 10px;
}

.edit-card {
  border: 1px solid #10b981;
}

@media (max-width: 480px) {
  .categories-admin {
    padding: 16px 12px;
  }

  .page-header h1 {
    font-size: 2.2rem;
  }

  .section-card {
    padding: 16px 12px;
    border-radius: 8px;
  }

  .section-card h2 {
    font-size: 1.8rem;
  }

  .btn-primary,
  .btn-green,
  .btn-outline {
    width: 100%;
    text-align: center;
  }

  .section-card-header {
    flex-direction: column;
    align-items: stretch;
  }
}
</style>